import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { UserProfileActionType, UserProfileStore } from './UserProfileReducer.types';

// @ts-ignore
export const initialState: UserProfileStore = Immutable.fromJS({
  data: {},
  permissions: [],
  isFetching: false,
  isFetchingAchievements: false,
  isFetchingCompetitions: false,
  achievements: [],
  competitions: [],
  invalidUser: false,
});

const UserProfileReducer = handleActions<any>(
  {
    USER_PROFILE_REQUEST: (state: UserProfileStore) => state.set('isFetching', true),

    USER_PROFILE_RESPONSE_FAILURE: (state: UserProfileStore) => state.set('isFetching', false),

    USER_PROFILE_RESPONSE: (state: UserProfileStore, action: UserProfileActionType) =>
      state.set('isFetching', false).set('data', Immutable.fromJS(action.payload.data)),

    USER_ACHIEVEMENTS_REQUEST: (state: UserProfileStore) => state.set('isFetchingAchievements', true),

    USER_ACHIEVEMENTS_RESPONSE_FAILURE: (state: UserProfileStore) => state.set('isFetchingAchievements', false),

    USER_ACHIEVEMENTS_RESPONSE: (state: UserProfileStore, action: UserProfileActionType) =>
      state.set('isFetchingAchievements', false).set('achievements', Immutable.fromJS(action.payload.data)),

    USER_COMPETITIONS_PROFILE_REQUEST: (state: UserProfileStore) => state.set('isFetchingCompetitions', true),

    USER_COMPETITIONS_PROFILE_RESPONSE_FAILURE: (state: UserProfileStore) => state.set('isFetchingCompetitions', false),

    USER_COMPETITIONS_PROFILE_RESPONSE: (state: UserProfileStore, action: UserProfileActionType) =>
      state.set('isFetchingCompetitions', false).set('competitions', Immutable.fromJS(action.payload.data)),

    USER_PERMISSIONS_RESPONSE: (state: UserProfileStore, action: UserProfileActionType) =>
      state.set('isFetchingCompetitions', false).set('permissions', Immutable.fromJS(action.payload.data)),

    INVALID_USER: (state: UserProfileStore) => state.set('isFetching', false).set('invalidUser', true),

    AUTHENTICATION_LOGOUT: () => initialState,

    CLEAN_USER_PROFILE: () => initialState,
  },
  initialState
);

export default UserProfileReducer;
